import GlobalFeed from '@/components/community/GlobalFeed.vue';
import { mountCommunityComponentAsApp } from '@/entrypoints/helpers/community-mounter';

mountCommunityComponentAsApp(GlobalFeed, '#community-feed-container').catch(
  console.error
);
